import { render, staticRenderFns } from "./FormServer3Streamax.vue?vue&type=template&id=6864cbda&scoped=true&"
import script from "./FormServer3Streamax.vue?vue&type=script&lang=ts&"
export * from "./FormServer3Streamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormServer3Streamax.vue?vue&type=style&index=0&id=6864cbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864cbda",
  null
  
)

export default component.exports